module.exports = __webpack_public_path__ + "img/m-plan-1-3.d5b43b71.png";